import NavigationBar from './NavigationBar';
import { Outlet } from 'react-router-dom';

function AppLayout() {
  return (
    <div className="flex flex-col h-screen">
      <NavigationBar />
      <main className="flex flex-1 overflow-hidden">
        <Outlet />
      </main>
    </div>
  );
}

export default AppLayout;